"use client";
import { useEffect, useState } from "react";
import ModalPopup from "./ModalPopup";
import { getStrapiURL } from "@aicodepro/web-builder-utils";

export default function FormSubmit({
  placeholder,
  text,
}: {
  placeholder: string;
  text: string;
}) {
  const [email, setEmail] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const token = process.env.AICODEPRO_FORM_SUBMISSION_TOKEN;

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const [showModal, setShowModal] = useState(false);

  async function handleSubmit() {
    if (email === "") {
      setErrorMessage("Email cannot be blank.");
      return;
    }

    if (!emailRegex.test(email)) {
      setErrorMessage("Invalid email format.");
      return;
    }

    const res = await fetch(
      getStrapiURL() + "/api/web-builder/lead-form-submissions",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ data: { email } }),
      }
    );

    if (!res.ok) {
      setErrorMessage("Email failed to submit.");
      return;
    }
    setErrorMessage("");
    setEmail("");

    setShowModal(true);
  }

  return (
    <div className="flex flex-row items-center lg:w-[350px] md:w-[320px] w-[300px] self-center justify-start flex-shrink-0">
      <div className="flex flex-col lg:w-[390px] xl:w-[410px] md:-w-[350px] w-[350px]">
        <div className="flex flex-row relative">
          {successMessage ? (
            <p className="text-green-700 bg-green-300 px-4 py-2 rounded-lg">
              {successMessage}
            </p>
          ) : (
            <>
              <input
                type="email"
                placeholder={errorMessage || placeholder}
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                className={
                  "lg:w-4/5 md:w-5/6 xl:w-5/6 p-3 rounded-l-lg bg-th-subtitle-col w-5/6 text-th-textcol-3"
                }
              />
              <button
                type="button"
                className="px-3 py-3 font-semibold rounded-r-3xl lg:w-1/4 xl:w-1/4 md:w-1/4 w-1/4 bg-th-btncol-1 text-th-btntext-2 hover:bg-th-btncol-2 text-justify text-evenly "
                onClick={handleSubmit}
              >
                {text}
              </button>
            </>
          )}
        </div>

        {errorMessage && (
          <p className="text-red-500 bg-red-200 px-4 py-2 rounded-lg my-2">
            {errorMessage}
          </p>
        )}
      </div>
      <ModalPopup show={showModal} />
    </div>
  );
}
